import { defineComponent as _defineComponent } from 'vue'
import { defineValidation } from "@/core/app.service";
import { store } from "@/store";
import { computed, onMounted, ref } from "vue";
import { v4 as uuidv4 } from "uuid";



export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    label: null,
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    type: { default: "text" },
    multiple: { type: Boolean },
    inputClass: null,
    labelClass: null,
    value: null,
    id: null,
    maxlength: null,
    error: null,
    name: null,
    accept: { default: "" },
    autocomplete: { default: "on" },
    showErrorText: { type: Boolean, default: true },
    showRequiredStar: { type: Boolean, default: true },
    maxValue: { default: null },
    step: { default: null },
    icon: { default: null },
    customAriaErrorMessageId: { default: null },
    customAriaInvalid: { type: Boolean, default: null }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({(e: "input", value: string): void, (e: "change", value: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { label?: string, disabled?: boolean, readonly?: boolean, type: string, multiple?: boolean, inputClass?: string, labelClass?: string, value?: string, id?: string, maxlength?: number, error?: string, name?: string, accept: string, autocomplete: string, showErrorText: boolean, showRequiredStar: boolean, maxValue: number | null, step: string | number | null, icon: string | null, customAriaErrorMessageId: string, customAriaInvalid: boolean }

const input = ref(null);





const borderColor = computed<OpacityFunction>(() => store.getters["app/borderColor"]);
const textColor = computed<OpacityFunction>(() => store.getters["app/textColor"]);
const filesUploadString = ref<any>("");
const btnHover = ref<boolean>(false);
const uniqueId = `input-${uuidv4()}`;
const inputId = computed(() => props.id || uniqueId); // Generate a unique ID if not provided


function setBtnHover(val: boolean) {
    if (!isFileUpload.value) {
        return;
    }
    btnHover.value = val;
}



const hasValue = computed<boolean>(() => !!props.value);
onMounted(() => {
    // If browser preserves the value of fields
    setTimeout(() => {
        if (input.value && input.value.value) {
            emit("input", input.value.value);
        }
    },
    200);
    
});

function updateValue(e) {
    setFilesUploadString(e);
    emit("input", e.target.value);
}

function updateChange(e) {
    updateValue(e);
    setFilesUploadString(e);
    emit("change", e.target.value);
}

const isFileUpload = computed<boolean>(() => props.type === "file");

function setFilesUploadString(e:any) {
    if (isFileUpload.value) {
        filesUploadString.value = "";
        const files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            filesUploadString.value += files[i].name;
            if (i < files.length - 1) {
                filesUploadString.value += ', ';
            }
        }
    }
}

const defaultAriaErrorMessageId = 'defaultAriaErrorMessageIdFor' + props.id + props.name;

const computedAriaInvalid = computed(() => {
  if (props.customAriaInvalid !== null && props.customAriaInvalid !== undefined) {
    return props.customAriaInvalid;
  }
  return !!props.error && props.showErrorText ? 'true' : undefined;
});


const computedAriaErrorMessageId = computed(() => {
  if (props.customAriaErrorMessageId) {
    return props.customAriaErrorMessageId;
  }
  return props.error && props.showErrorText ? defaultAriaErrorMessageId : undefined;
});

onMounted(defineValidation(props.name, () => props.value));

return { __sfc: true,input, props, emit, borderColor, textColor, filesUploadString, btnHover, uniqueId, inputId, setBtnHover, hasValue, updateValue, updateChange, isFileUpload, setFilesUploadString, defaultAriaErrorMessageId, computedAriaInvalid, computedAriaErrorMessageId }
}

})